(function ($) {
  var seasonalPromoV1 = {
    init: function (context, settings) {
      $('.seasonal-promo-v1 .promo').once('seasonal-promo-v1-template').each(function () {
        var thisFormatter = $(this);
        // setup active area
        var promos = thisFormatter.find('.active-promo').find('.sp-product-v1');

        promos.each(function (i) {
          $(this).attr('item', 'item-' + i);
        });

        // setup sidebar
        var visibleItems = 3;
        var items = thisFormatter.find('.slides').find('.sp-product-v1');

        items.each(function (i) {
          $(this).attr('item', 'item-' + i);
        });

        // show carousel if more items
        if (items.length > visibleItems) {
          for (var i = 0; i < items.length; i += visibleItems) {
            items.slice(i, i + visibleItems).wrapAll('<li></li>');
          }

          var flexsliderID = '#' + thisFormatter.find('.flexslider').attr('id');
          var flexslider = $(flexsliderID);
          var flexsliderDir = flexslider.data('direction');
          var rtl = flexsliderDir && flexsliderDir == 'rtl' ? true : false;

          flexslider.flexslider({
            animation: 'slide',
            animationLoop: true,
            direction: 'vertical',
            slideshow: false,
            rtl: rtl
          }).addClass('flexslider-active');
        }

        // hover state
        thisFormatter.find('.flexslider-nav .thumbnail').hover(function () {
          $(this).addClass('hover');
        }, function () {
          $(this).removeClass('hover');
        });

        // active state
        thisFormatter.find('.flexslider-nav .thumbnail').first().addClass('active');
        thisFormatter.find('.flexslider-nav .thumbnail img').on('click', function() {
          var item = $(this).parents('.sp-product-v1').attr('item');

          thisFormatter.find('.flexslider-nav .thumbnail').removeClass('active');
          $(this).parents('.thumbnail').addClass('active');
          thisFormatter.find('.active-promo').find('.sp-product-v1').hide();
          thisFormatter.find('.sp-product-v1[item=' + item + ']').show();
        });
      });
    }
  };

  $(window).on('load', function() {
    seasonalPromoV1.init();
  });
})(jQuery);
